export const normalizeTaskTabHash = (hash = "") => {
    if (!hash) return ""

    const [hashPath] = hash.split("?")
    return hashPath.replace(/\/$/, "")
}

export const getTaskIdFromHash = (hash = "") => {
    if (!hash || !hash.includes("?")) return ""

    const queryString = hash.split("?").slice(1).join("?")
    return new URLSearchParams(queryString).get("task_id") || ""
}

export const buildTaskDetailLocation = (location, taskId) => {
    const nextSearchParams = new URLSearchParams(location?.search || "")
    nextSearchParams.set("task_id", taskId)

    return {
        pathname: location?.pathname || "",
        search: `?${nextSearchParams.toString()}`,
        hash: location?.hash || "",
    }
}
